import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const portfolioRoutes: RouteRecordRaw[] = [
  {
    path: routes.PORTFOLIO,
    name: 'PORTFOLIO',
    component: () => import('./PortfolioPage.vue'),
    meta: {
      requiresAuth: true,
      fullHeight: true,
      title: 'Portfolio',
      eyebrow: 'Your holdings and returns',
    },
  },
  {
    path: routes.INVESTMENT_DETAIL,
    name: 'INVESTMENT_DETAIL',
    component: () => import('./InvestmentDetailPage.vue'),
    meta: { requiresAuth: true, fullHeight: true, title: 'Investment Details' },
  },
  {
    path: routes.INVESTMENT_PAYOUTS,
    name: 'INVESTMENT_PAYOUTS',
    component: () => import('./PayoutHistoryPage.vue'),
    meta: { requiresAuth: true, fullHeight: true, title: 'Payout history' },
  },
]
